import iframeService from '@/services/iframeService';

export class Message {
    constructor (type, data) {
        this.type = type;
        this.data = data;
    }
}

export function hostRedirect (redirectUrl) {
    const message = new Message('redirect', { redirectUrl });
    if (iframeService.isAppIframed()) {
        window.parentIFrame.sendMessage(message);
    }
    window.location.href = redirectUrl;
}
